import React, {Component} from 'react';
import {Button, Layout, Typography} from "antd";
import OpenSheetMusicDisplay from "../../components/OpenSheetMusicDisplay";
import MIDISounds from 'midi-sounds-react';
import {CaretRightOutlined} from '@ant-design/icons';
import {MidiPlayer} from "./MidiPlayer";
import {triads} from "./triads";
import {MusicXml} from "./MusicXml";

const {Content} = Layout;

export default class TriadInversionsContainer extends Component {

    render() {
        return <Layout style={{background: '#fff', margin: '0 24px', padding: '0'}}>
            <Content style={{padding: '12px'}}>
                <div style={{textAlign: 'left'}}>
                    <Typography.Title level={3} style={{textTransform: 'uppercase', margin: '0'}}>
                        Przewroty trójdźwięków
                    </Typography.Title>

                    <div style={{display: 'none'}}>
                        <MIDISounds
                            ref={(ref) => (this.midiSounds = ref)}
                            appElementName="root" instruments={[3]}
                        />
                    </div>

                    <p style={{marginTop: '16px'}}>
                        Każdy trójdźwięk posiada trzy postacie:
                    </p>
                    <ul>
                        <li>zasadnicza (z prymą w najniższym głosie),</li>
                        <li>pierwszy przewrót (z tercją w najniższym głosie, zwany akordem sekstowym),</li>
                        <li>drugi przewrót (z kwintą w najniższym głosie, zwany akordem kwartsekstowym).</li>
                    </ul>

                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center'}}>
                        {triads.map((item, key) => {
                            return <div key={key} style={{width: '450px', textAlign: 'center'}}>
                                <OpenSheetMusicDisplay
                                    file={MusicXml.buildTriadInversionsMusicXML(item)}
                                    drawTitle={false}
                                    autoResize={true}
                                    backend={'svg'}
                                    drawPartNames={false}
                                    drawCredits={false}
                                    stretchLastSystemLine={true}
                                />
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '5px'
                                }}>
                                    <Button icon={<CaretRightOutlined/>}
                                            onClick={() => MidiPlayer.playTriadInversion(this.midiSounds, item)}></Button>
                                    <div>{item.name}</div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </Content>
        </Layout>
    }
}
